export const setInitalPagination = (state: any, items: any[]) => {
  const itemsPerPage = 10;
  const totalPages = items ? Math.ceil(items.length / itemsPerPage) : 1
  const currentPage = 1;
  state.pagination = { itemsPerPage, totalPages, currentPage };
};